import { Button } from '@/components/ui/button';
import { ColumnDef } from '@tanstack/react-table';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { formatPhone } from 'src/utils/format-phone';
import { Lead } from 'src/trpc';

export const LeadsColumns: ColumnDef<Lead>[] = [
  {
    accessorKey: 'phone',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Phone Number
          {!column.getIsSorted() && <ArrowUpDown className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'asc' && <ArrowUp className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'desc' && <ArrowDown className="ml-2 h-4 w-4" />}
        </Button>
      );
    },
    accessorFn: (row) => formatPhone(row.phone || ''),
  },
  {
    accessorKey: 'createdAt',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Date Created
          {!column.getIsSorted() && <ArrowUpDown className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'asc' && <ArrowUp className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'desc' && <ArrowDown className="ml-2 h-4 w-4" />}
        </Button>
      );
    },
    accessorFn: (row) => row.createdAt ? new Date(row.createdAt).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }) : 'No date',
  },
];